import { ApplicationNames } from './shared-application.constants';

export class PortfolioConstants {

	public static readonly PORTFOLIO_CATEGORY = {
		BENCHMARK: 'Benchmark Portfolio',
		HYPOTHETICAL: 'Proposed Portfolio',
		MODEL_CURRENT: 'My Model Allocation',
		CLIENT_CURRENT: 'Client Portfolio',
		'TAX-REPORT': 'List of Holdings',
		MODEL_PORTFOLIO: 'Model Portfolio',
		THIRD_PARTY_MODEL: 'Advisor Model',
		PROSPECT_PORTFOLIO: 'Prospect Portfolio',
		CLIENT_PORTFOLIO: 'Client Portfolio',
		BPAS_PORTFOLIO: 'BPAS Portfolio',
		COMPARATIVE_BENCHMARK: 'Comparative Benchmark',
		ASSET_ALLOCATION: 'Asset Allocation',
		EXTERNAL_PORTFOLIO: 'External Portfolio'
	};

	public static readonly PORTFOLIO_CATEGORY_VALUE_TO_KEY = {
		'Benchmark Portfolio': 'BENCHMARK',
		'Proposed Portfolio': 'HYPOTHETICAL',
		'My Model Allocation': 'MODEL_CURRENT',
		'Client Portfolio': 'CLIENT_CURRENT', // This is for Filter Component purpose, and it is using CLIENT_CURRENT only
		'List of Holdings': 'TAX-REPORT',
		'Model Portfolio': 'MODEL_PORTFOLIO',
		'Advisor Model': 'THIRD_PARTY_MODEL',
		'Prospect Portfolio': 'PROSPECT_PORTFOLIO',
		'BPAS Portfolio': 'BPAS_PORTFOLIO',
		'Comparative Benchmark': 'COMPARATIVE_BENCHMARK',
		'Asset Allocation': 'ASSET_ALLOCATION'
	};

	public static readonly EXTERNAL_SOURCE = {
		ENVESTNET: 'Envestnet',
		BLACKDIAMOND: 'Black Diamond',
		ORION: 'Orion',
		SCHWAB: 'Charles Schwab'
	};

	public static readonly CUSTOM_PORTFOLIO_CATEGORIES = ['MODEL_CURRENT', 'CLIENT_CURRENT', 'BENCHMARK', 'HYPOTHETICAL', 'PROSPECT_PORTFOLIO'];
	public static readonly DETAILS_PORTFOLIO_CATEGORIES = ['MODEL_CURRENT', 'CLIENT_CURRENT', 'BENCHMARK', 'HYPOTHETICAL', 'TAX-REPORT', 'PROSPECT_PORTFOLIO'];
	public static readonly ENGAGEMENT_PORTFOLIO_CATEGORIES = ['CLIENT_PORTFOLIO', 'BPAS_PORTFOLIO'];
	public static readonly PORTFOLIO_CENTRE_PORTFOLIO_CATEGORIES = ['CLIENT_PORTFOLIO', 'COMPARATIVE_BENCHMARK', 'HYPOTHETICAL', 'MODEL_PORTFOLIO'];
	public static readonly TAX_LIST_PORTFOLIO_CATEGORY = 'TAX-REPORT';
	public static readonly TAX_LIST_APPS = [ApplicationNames.TAX_ESTIMATOR, ApplicationNames.DASHBOARD, ApplicationNames.MY_SAVED_PORTFOLIOS];

	public static readonly MISSING_DATA_VALUE = 'Missing data';
	public static readonly EXCEL_DEFAULT_PORTFOLIO_TYPE = 'Custom Model';

	public static readonly BLEND_TREE_ROOT = 'ROOT';
	public static readonly TREE_DEFAULT_NAME = 'Untitled Portfolio';

	public static readonly TRANSIENT_PORTFOLIO_ID = 'transient-portfolio';

	public static readonly POSITION_TYPE = {
		INVALID: 'INVALID',
		VALID: 'VALID',
		SUBSTITUTED: 'SUBSTITUTED'
	};
}
